import Button from "components/Button";
import styled from "styled-components";
import theme from "theme";

export const UserTypeCard = styled.div<{ isActive?: boolean }>`
    border-radius: 8px;
    padding: 10px;
    display: flex;
    width: 100px;
    height: 100px;
    padding: 10px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 14px;
    cursor: pointer;
    border: 1px solid;
    border-color: ${({ isActive }) =>
        isActive ? theme.colors.purple.primary : "#E8E5EB"};
`;

export const StyledButton = styled(Button)`
    width: 114px;
`;
